import React from "react";
import { Navigate, Outlet } from "react-router";
import useAuthValue from "../modules/authModule/hooks/useAuthValue";
import { ROUTE_NAME } from "./types/CommonTypes";

interface PrivateRouteProps {
  children?: JSX.Element;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const { isLoggedIn } = useAuthValue();
  return isLoggedIn ? (
    children ?? <Outlet />
  ) : (
    <Navigate to={"/" + ROUTE_NAME.LOGIN} />
  );
};

export default PrivateRoute;
